export default function imageStack() {
  const imageStacks = document.querySelectorAll(".image-stack");
  imageStacks.forEach(stack =>
    stack.addEventListener("click", () =>
      stack.classList.toggle("image-stack--is-stacked")
    )
  );
}
